module.exports = __webpack_public_path__ + "assets/513e1ef898bc2bc614fa68f286078f6d.png";